import { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  children: ReactNode;
} & HTMLAttributes<HTMLButtonElement>;

export default function ChatControlButton({ children, className, ...props }: Props) {
  return (
    <button
      type="button"
      className={cn(
        "text-white w-[1.5rem] aspect-square flex items-center justify-center group cursor-pointer shrink-0",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
